import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UpperCasePipe } from '@angular/common';
import { Seo } from '../../core/seo';
import { EQUIPMENT, STAGES } from '../../data/equipment';
import { Reveal } from '../../shared/reveal';
import { CountUp } from '../../shared/count-up';

@Component({
  selector: 'app-home',
  imports: [RouterLink, UpperCasePipe, Reveal, CountUp],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home implements OnInit {
  private readonly seo = inject(Seo);

  readonly stages = STAGES;
  readonly equipment = EQUIPMENT;
  readonly stats = [
    { value: 15,  suffix: '',     label: 'Equipment lines built in-house' },
    { value: 30,  suffix: '+',    label: 'Calibration services offered' },
    { value: 500, suffix: ' KLD', label: 'Plant capacity we design up to' },
    { value: 93,  suffix: '%',    label: 'Enquiry response rate' }
  ];

  ngOnInit(): void {
    this.seo.apply({
      title: 'Sewage & Effluent Treatment Plants | Mechtron Water Services, Vasai Virar',
      description:
        'Mechtron designs, manufactures, installs and commissions STP and ETP plants (MBBR, MBR, ' +
        'SBR, DAF) from 10 to 500 KLD in Vasai Virar, Maharashtra — plus an instrument calibration lab.',
      path: '/'
    });
  }
}
